import React from 'react';
import { AuthProvider } from './auth/AuthProvider';
import { ProtectedRoute } from './auth/ProtectedRoute';
import { AuthenticatedContent } from './auth/AuthenticatedContent';

/**
 * Root application component.
 * Wraps all content with AuthProvider for MSAL authentication context.
 * ProtectedRoute ensures only authenticated @royalcyber.com users can access content.
 */
const App: React.FC = () => {
  return (
    <AuthProvider>
      <ProtectedRoute>
        <AuthenticatedContent />
      </ProtectedRoute>
    </AuthProvider>
  );
};

export default App;
